export enum FinanceEntryType {
    BankBalance = 'bank-balance',
    MetalsInvoiceBalance = 'metals-invoice-balance',
    MetalsOrderBalance = 'metals-order-balance',
    PlasticsInvoiceBalance = 'plastics-invoice-balance',
    PlasticsOrderBalance = 'plastics-order-balance',
}
